// Topbar light/dark switch — the React counterpart of the PHP portal's
// sun/moon nav links. One button: it shows the icon for the mode you'd
// switch *to* and flips between explicit "light" and "dark" (a click is
// an explicit choice; "system" is only the untouched default).

import { Moon, Sun } from "lucide-react";
import { Button } from "@noc/ui";
import { useTheme } from "@/lib/theme";

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Light mode" : "Dark mode"}
      onClick={() => setTheme(isDark ? "light" : "dark")}
    >
      {isDark ? <Sun /> : <Moon />}
    </Button>
  );
}
